import { type FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel';
import { PageLayout } from 'dibs-elements/exports/PageLayout';

import { DesignSeriesBreadcrumbs } from './DesignSeriesBreadcrumbs/DesignSeriesBreadcrumbs';
import { DesignSeriesHero } from './DesignSeriesHero/DesignSeriesHero';
import { DesignSeriesCollection } from './DesignSeriesCollection/DesignSeriesCollection';
import { DesignSeriesCreator } from './DesignSeriesCreator/DesignSeriesCreator';
import { DesignSeriesEditorial } from './DesignSeriesEditorial/DesignSeriesEditorial';

import { type DesignSeriesLayout_viewer$data } from './__generated__/DesignSeriesLayout_viewer.graphql';

import styles from './DesignSeriesLayout.scss';

type Props = {
    viewer: DesignSeriesLayout_viewer$data;
};

const DesignSeriesLayoutComponent: FC<Props> = props => {
    const { viewer } = props;
    const { iconicDesignSeriesPage, isWordpressArticlesEnabled } = viewer;

    if (!iconicDesignSeriesPage) {
        return null;
    }

    return (
        <PageLayout setOffset={false} setViewportBackground="sassyColorWhite">
            <HeadingLevel>
                {HeadingLevel2 => (
                    <div className={styles.container}>
                        <DesignSeriesBreadcrumbs iconicDesignSeriesPage={iconicDesignSeriesPage} />
                        <DesignSeriesHero iconicDesignSeriesPage={iconicDesignSeriesPage} />
                        <div className={styles.designsContainer}>
                            <DesignSeriesCollection
                                Heading={HeadingLevel2}
                                iconicDesignSeriesPage={iconicDesignSeriesPage}
                            />
                            <DesignSeriesCreator
                                iconicDesignSeriesPage={iconicDesignSeriesPage}
                                viewer={viewer}
                            />
                        </div>
                        {isWordpressArticlesEnabled && (
                            <DesignSeriesEditorial
                                iconicDesignSeriesPage={iconicDesignSeriesPage}
                            />
                        )}
                    </div>
                )}
            </HeadingLevel>
        </PageLayout>
    );
};

export const DesignSeriesLayout = createFragmentContainer(DesignSeriesLayoutComponent, {
    viewer: graphql`
        fragment DesignSeriesLayout_viewer on Viewer {
            isWordpressArticlesEnabled: isEnabledByLocale(featureName: "WP_EDITORIAL")
            ...DesignSeriesCreator_viewer
            iconicDesignSeriesPage(designSeriesName: $designSeriesName) {
                ...DesignSeriesCollection_iconicDesignSeriesPage
                ...DesignSeriesBreadcrumbs_iconicDesignSeriesPage
                ...DesignSeriesHero_iconicDesignSeriesPage
                ...DesignSeriesCreator_iconicDesignSeriesPage
                ...DesignSeriesEditorial_iconicDesignSeriesPage
            }
        }
    `,
});
